<template>
  <v-container fluid>
    <div class="toolbar d-flex flex-row justify-space-between align-center elevation-3 mb-3">
      <span>
        Lazada Order
      </span>
      <div class="d-flex">
        <v-select
          v-model="brandSelected"
          label="Brand"
          :items="allBrand"
          outlined
          dense
          class="mr-2"
          hide-details
          @change="getItems(true)" />
        <v-text-field
          v-model.trim="inputSearch"
          hide-details
          label="Search"
          append-icon="mdi-magnify"
          dense
          outlined
          @keydown.enter="getItems(true)">
        </v-text-field>
        <v-btn
          color="info"
          size=""
          class="ml-2"
          :loading="loading"
          @click="syncWaitingOrder">
          <v-icon>
            mdi-sync
          </v-icon>
          Sync Waiting
        </v-btn>
        <v-btn
          color="dark"
          size=""
          class="ml-2"
          :loading="loading"
          @click="showDialogSyncOrderCancel = true">
          <v-icon>
            mdi-sync
          </v-icon>
          Sync Cancel
        </v-btn>
      </div>
    </div>

    <v-row class="px-8">
      <v-col
        cols="12"
        class="card-container elevation-3">
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :items-per-page="options.itemsPerPage"
          :server-items-length="total"
          :loading="loading"
          :footer-props="{'items-per-page-options': [15, 25, 50, 100]}"
          @update:options="getItems()">
          <template #[`item.orderId`]="{ item }">
            <div> <b>Order ID : </b>{{ item.orderId }}</div>
            <div> <b>Lazada Order ID : </b>{{ item.lazadaOrderId }}</div>
          </template>
          <template #[`item.detail`]="{ item }">
            <div> <b>Status : </b>{{ mapStatus(item.lazadaStatus) | toCapitalize() }}</div>
            <div> <b>Create Time </b>{{ (item.createdAt) | dateTimeFormat() }}</div>
            <div> <b>Payment Method : </b>{{ item.paymentMethod }}</div>
          </template>
          <template #[`item.items`]="{ item }">
            <div class="pa-2">
              <v-simple-table style="border: 1px solid #858585;">
                <thead>
                  <tr>
                    <th>Photo</th>
                    <th>Name</th>
                    <th>Option</th>
                    <th>Qty</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(product, index) of item.items"
                    :key="`${item.id}-${index}`">
                    <td>
                      <v-img
                        :src="product.productMainImage"
                        width="100"
                        height="100"
                        contain
                        class="my-2" />
                    </td>
                    <td class="text-left">
                      {{ product.name }}
                    </td>
                    <td class="text-left">
                      {{ product.variation }}
                    </td>
                    <td>
                      1
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog
      v-model="showDialogSyncOrderWaiting"
      max-width="500px">
      <v-card>
        <v-card-title class="headline">
          Sync Waiting Order Result
        </v-card-title>
        <v-card-text>
          <p class="pa-0 mb-0">
            <b> Lazada order count : </b> {{ syncWaitingOrderResult.lazadaOrderCount }}
          </p>
          <p class="pa-0">
            <b> New order count : </b> {{ syncWaitingOrderResult.newOrderCount }}
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showDialogSyncOrderCancel"
      max-width="500px">
      <v-card>
        <v-card-title class="headline">
          Sync Cancel Order
        </v-card-title>
        <v-card-text>
          <p class="pa-0">
            <b> Brand : </b> {{ brandSelected }}
          </p>
          <div
            class="d-flex"
            style="justify-items: center; align-items: center; gap: 1rem;">
            <div style="width: 40%">
              <gw-date-picker
                v-model="syncStartDate"
                :loading="loading"
                label="Start Date" />
            </div>
            <div style="width: 40%">
              <gw-date-picker
                v-model="syncEndDate"
                :loading="loading"
                label="End Date" />
            </div>

            <v-btn
              color="info"
              small
              class="ml-2"
              :loading="loading"
              @click="syncCancelOrder">
              submit
            </v-btn>
          </div>
          <div v-if="syncCancelOrderResult.lazadaOrderCount">
            <p class="pa-0 mb-0">
              <b> Lazada order count : </b> {{ syncCancelOrderResult.lazadaOrderCount }}
            </p>
            <p class="pa-0">
              <b> New order count : </b> {{ syncCancelOrderResult.cancelCount }}
            </p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ProductAttributeProvider from '@/resources/ProductAttributeProvider'
import LazadaOrderProvider from '@/resources/LazadaOrderProvider'

const ProductAttributeService = new ProductAttributeProvider()
const LazadaOrderService = new LazadaOrderProvider()

export default {
  data () {
    return {
      headers: [
        {
          text: 'Order Id',
          value: 'orderId',
          width: '300px',
          sortable: false
        },
        {
          text: 'Details',
          value: 'detail',
          width: '300px',
          sortable: false
        },
        {
          text: 'Items',
          value: 'items',
          sortable: false,
          align: 'center'
        }
      ],
      showDialogSyncOrderCancel: false,
      showDialogSyncOrderWaiting: false,
      syncStartDate: null,
      syncEndDate: null,
      syncCancelOrderResult: {
        lazadaOrderCount: null,
        cancelCount: null
      },
      syncWaitingOrderResult: {
        lazadaOrderCount: 0,
        newOrderCount: 0
      },
      items: [],
      inputSearch: '',
      brandSelected: 'Gentlewoman',
      allBrand: ['Gentlewoman'],
      total: 0,
      options: {
        page: 1,
        itemsPerPage: 25,
        sortBy: ['createdAt'],
        sortDesc: [true]
      },
      loading: false
    }
  },
  watch: {
    'query.page': {
      handler () {
        this.getItems()
      },
      deep: true
    },
    showDialogSyncOrderCancel (val) {
      if (val === false) {
        this.syncCancelOrderResult = {
          lazadaOrderCount: null,
          cancelCount: null
        }
      }
    }
  },
  async mounted () {
    await this.getAttribute()
    await this.getItems(true)
  },
  methods: {
    mapStatus (status) {
      return status.replaceAll('_', ' ')
    },
    async getAttribute () {
      try {
        this.loading = true

        const { data: brands } = await ProductAttributeService.getProductAttribute('brands', {
          limit: 9999,
          sortBy: 'createdAt',
          sortOrder: 'asc'
        })

        this.allBrand = brands.results.map((brand) => brand.name)
      } catch (error) {
        console.error('brands: ', error)
      } finally {
        this.loading = false
      }
    },
    async syncWaitingOrder () {
      try {
        this.loading = true
        const { data } = await LazadaOrderService.syncWaitingOrder({
            brand: this.brandSelected
        })

        this.syncWaitingOrderResult = {
          lazadaOrderCount: data.lazadaOrderCount,
          newOrderCount: data.newOrders.length
        }
        this.showDialogSyncOrderWaiting = true
      } catch (error) {
        console.error('syncWaitingOrder', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    async syncCancelOrder () {
      try {
        if (!this.syncStartDate || this.syncStartDate === null || !this.syncEndDate || this.syncEndDate === null) {
          this.$store.dispatch('Components/setSnackbar', {
            value: true,
            message: 'Please select start date and end date',
            type: 'error'
          })

          return
        }
        this.loading = true
        const { data } = await LazadaOrderService.syncCancelOrder({
          brand: this.brandSelected,
          startDate: this.syncStartDate,
          endDate: this.syncEndDate
        })

        this.syncCancelOrderResult = {
          lazadaOrderCount: data.lazadaOrderCount,
          cancelCount: data.cancelOrders.length
        }
      } catch (error) {
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    async getItems (isClear = false) {
      try {
        this.loading = true

        if (isClear) {
          this.items = []
          this.options.page = 1
        }

        const { data } = await LazadaOrderService.getOrders({
            page: this.options.page,
            limit: this.options.itemsPerPage,
            brand: this.brandSelected,
            sortBy: this.options.sortBy[0],
            sortOrder: this.options.sortDesc[0] ? 'desc' : 'asc',
            search: this.inputSearch
          })

        this.items = (data?.results || [])
        this.total = data?.total || 0
      } catch (error) {
        console.error('getItems', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.toolbar {
  position: sticky;
  top: 70px;
  left: 0;
  width: 100%;
  z-index: 5;
  background-color: #fff;
  padding: 1.25rem 1.875rem;
  border-radius: 0.625rem;
}
.toolbar span {
  font-weight: bold;
  font-size: 1.25rem;
}
.card-container {
  padding: 1.25rem 1.875rem;
  background-color: #fff;
  border-radius: 0.625rem;
  margin-top: 1.25rem;
  min-height: calc(100vh - 200px);
}
.card-title {
  font-weight: bold;
  font-size: 1.35rem;
}
.paginate-container {
  padding: 0.25rem;
  background-color: #fff;
  border-radius: 1rem;
  margin-top: 0.5rem;
}
</style>

<style>
.search-box .v-input__control {
  max-width: unset !important;
  min-height: 28px !important;
  max-height: 28px !important;
}
.search-box .v-input__slot {
  max-width: unset !important;
  min-height: 28px !important;
  max-height: 28px !important;
}
</style>
